















import Vue from 'vue';

import { Repository } from '@/db/_repo';
const db = new Repository();

import subItem    from '@/components/app/subscription-item.vue';
import trialbtn   from '@/components/btn-freetrial.vue';

export default Vue.extend({
    components: {
        'sub-item': subItem,
        trialbtn,
    },
    data() {
        return {
            noSubs: false,
            noActiveSubs: false,
            subs: [],
            activeSubs: []
        }
    },
    created() {
        this.$bind('subs', db.subscriptions.getUserSubs(this.currentUser.uid)).then((val) => {
            if (this.subs.length < 1) {
                this.noSubs = true;
                this.noActiveSubs = true;
            } else {
                this.activeSubs = this.subs.filter(sub => sub.active === true);
                if (this.activeSubs.length < 1) {
                    this.noActiveSubs = true;
                }
            }
        });
    }
})
